//#region src/components/ScalarCombobox/types.ts
/** Type guard to check if an option is a group */
function isGroup(option) {
	return option?.options !== void 0;
}
/** Type guard to check if an array of options is an array of groups */
function isGroups(options) {
	if (!options[0]) return false;
	return isGroup(options[0]);
}
//#endregion
export { isGroups };

//# sourceMappingURL=types.js.map